import { nameOf } from "../../../../utils/functions/ReflectionUtil";
import { ColumnField } from "../../../components/GenericTable/SubComponents/Column";
import { Role } from "../../../../core/models/entities/Role";
import { Design } from "../../../../core/models/entities/Design";
import { useProfileContext } from "../../../../contexts/ProfileContext";
import { useTranslation } from "react-i18next";

export function designColumnsConfig(showVendorColumn: boolean = false) {
  const { role } = useProfileContext();
  const { t } = useTranslation();

  // Vendor column (only for Admin role)
  const vendorColumn = {
    value: "vendor",
    canSortBy: true,
    displayValue: t("vendor"),
    weight: 1,
  } as ColumnField;

  const baseColumns = [
    {
      value: nameOf<Design>((x) => x.displayImage),
      canSortBy: false,
      displayValue: t("image"),
      weight: 1,
    },
    {
      // The cell shows MUL plus manufacturer/model; sorting goes by style
      // (backend sortByField 'style' - flag-gated on the API side).
      value: "style",
      canSortBy: true,
      displayValue: t("mul"),
      title: t("designListStyle.sortByStyle"),
      weight: 1.3,
    },
    {
      value: nameOf<Design>((x) => x.title),
      canSortBy: true,
      displayValue: t("title"),
      weight: 0,
    },
  ];

  // Customer column
  const customerColumn = {
    value: nameOf<Design>((x) => x.customer),
    canSortBy: true,
    displayValue: t("customer"),
    weight: 1.65,
  } as ColumnField;

  const remainingColumns = [
    {
      value: nameOf<Design>((x) => x.createdAtUtc),
      canSortBy: true,
      displayValue: t("designListStyle.creationDate"),
      weight: 1.2,
    },
    {
      value: nameOf<Design>((x) => x.status),
      canSortBy: true,
      displayValue: t("status"),
      weight: role === Role.EndUser ? 2 : 1.5,
    },
    {
      value: "action",
      canSortBy: false,
      displayValue: t("action"),
      weight: 1.5,
    },
  ];

  const columns: ColumnField[] = [...baseColumns];

  // Add vendor column before customer column if requested (for Admin role)
  if (showVendorColumn) {
    columns.push(vendorColumn);
  }

  // Always add customer column
  columns.push(customerColumn);

  columns.push(...remainingColumns);

  return columns;
}
